import React from 'react';
import Categories from './PhoneCategories/Categories/Categories';

const AllCategories = () => {
    return (
        <div>
            <Categories></Categories>
        </div>
    );
};

export default AllCategories;